const PdfIcon = ({ width = '100%', height = '100%', ...props }: any) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.395406 0.395467C0.142232 0.648641 0 0.992019 0 1.35006V20.2501C0 20.6081 0.142232 20.9515 0.395406 21.2047C0.64858 21.4578 0.991958 21.6001 1.35 21.6001H14.85C15.208 21.6001 15.5514 21.4578 15.8046 21.2047C16.0578 20.9515 16.2 20.6081 16.2 20.2501V6.35451C16.1999 5.9965 16.0576 5.65318 15.8045 5.40006L10.8 0.395611C10.5469 0.14242 10.2036 0.000137496 9.84555 6.10352e-05H1.35C0.991958 6.10352e-05 0.64858 0.142293 0.395406 0.395467ZM1.35 1.35006H9.45V5.40006C9.45 5.7581 9.59223 6.10148 9.84541 6.35465C10.0986 6.60783 10.442 6.75006 10.8 6.75006H14.85V20.2501H1.35V1.35006ZM10.8 5.40006V2.30451L13.8955 5.40006H10.8ZM8.825 8.99967C8.825 8.64069 8.53399 8.34967 8.175 8.34967C7.81602 8.34967 7.525 8.64069 7.525 8.99967V12.4566L4.46558 14.2923C4.15775 14.477 4.05793 14.8763 4.24263 15.1841C4.42733 15.4919 4.8266 15.5917 5.13442 15.407L8.19497 13.5707L11.6959 15.4241C12.0131 15.5921 12.4065 15.4711 12.5745 15.1538C12.7424 14.8365 12.6214 14.4432 12.3041 14.2752L8.825 12.4333V8.99967Z"
      fill="#FC493D"
    />
  </svg>
)

export default PdfIcon
